import GeneratingKeyPairsMac from "../../../../src/courses/partials/ssh/mac/generating-key-pairs.mdx";
import * as React from 'react';
export default {
  GeneratingKeyPairsMac,
  React
};